import React from 'react';
import Orders from 'features/orders/orders';
import { useOrdersContext } from 'features/orders/use-orders';

const WrapperOrders = () => {
  return (
    <useOrdersContext.Provider>
      <Orders />
    </useOrdersContext.Provider>
  );
};

export default WrapperOrders;
